module.exports = __webpack_public_path__ + "img/news-3.2930854e.jpg";